import React from "react";
import { useLang } from "../context/LangContext";
import Reveal from "./Reveal";

const COPY = {
  fr: {
    overline: "MANIFESTE · CERCLE PRIVÉ",
    headline: "Le véritable luxe n'est pas le temps. C'est de retrouver pleinement ses capacités physiques, son énergie et sa liberté de mouvement.",
    chapters: ["Le cercle", "Le protocole", "La promesse"],
    paras: [
      "Riviera Shockwaves est un cercle privé dédié aux personnes qui considèrent que leur corps est leur actif le plus précieux.",
      "Nous proposons un accès extrêmement sélectif à des protocoles de régénération avancés, destinés aux propriétaires de yachts, équipages, dirigeants, entrepreneurs, sportifs et clients VIP les plus exigeants.",
      "Notre mission est simple : permettre à chacun de récupérer plus vite, retrouver davantage de mobilité, améliorer son confort physique et maintenir durablement son niveau de performance.",
      "Quand la plupart des approches proposent du confort ou du bien-être, nous nous concentrons sur un objectif différent : aider le corps à retrouver son plein potentiel.",
    ],
    pull: "Nous ne vendons pas des soins. Nous aidons les personnes les plus exigeantes à retrouver un niveau physique qu'elles pensaient parfois avoir perdu.",
    paras2: [
      "Nos protocoles exclusifs associent plusieurs technologies de stimulation et de régénération de dernière génération, sélectionnées et adaptées individuellement par nos spécialistes.",
      "Chaque intervention est unique. Chaque personne reçoit un protocole personnalisé. Chaque expérience est conçue pour produire un impact concret sur le physique, l'énergie et la capacité à profiter pleinement de son activité professionnelle, sportive ou personnelle.",
      "Les prestations sont réalisées à bord des yachts, dans les villas privées, hôtels de prestige, clubs privés ou lors d'événements exclusifs, avec un niveau de discrétion et de service conforme aux standards du luxe international.",
      "En complément, Riviera Shockwaves s'associe à Exomobil pour proposer des expériences uniques autour de la mobilité augmentée, des exosquelettes et des technologies humaines de nouvelle génération.",
    ],
    closing_hl: "Quand les autres proposent du confort, nous proposons de récupérer des capacités.",
    closing: [
      "Riviera Shockwaves n'est pas un service de bien-être.",
      "C'est une nouvelle approche de la régénération, de la récupération et de la performance humaine.",
    ],
    signature_top: "SUR INVITATION UNIQUEMENT",
    signature_main: "Nous vous rendons vos capacités.",
    signature_sub: "Protocoles de régénération d'élite — à bord, sur invitation ou demande personnalisée.",
  },
  en: {
    overline: "MANIFESTO · PRIVATE CIRCLE",
    headline: "True luxury isn't time. It is recovering your full physical capacity, your energy and your freedom of movement.",
    chapters: ["The circle", "The protocol", "The promise"],
    paras: [
      "Riviera Shockwaves is a private circle dedicated to those who consider their body to be their most precious asset.",
      "We grant extremely selective access to advanced regeneration protocols designed for yacht owners, crews, executives, entrepreneurs, athletes and the most demanding VIP clients.",
      "Our mission is simple: allow each member to recover faster, regain mobility, improve physical comfort and sustain their level of performance over time.",
      "Where most approaches offer comfort or wellness, we focus on a different objective: helping the body recover its full potential.",
    ],
    pull: "We do not sell treatments. We help the most demanding people regain a physical level they sometimes thought they had lost.",
    paras2: [
      "Our exclusive protocols combine several state-of-the-art stimulation and regeneration technologies, selected and tailored by our specialists for each individual.",
      "Every intervention is unique. Every person receives a personalised protocol. Every experience is designed to produce a tangible impact on the body, energy and ability to fully enjoy professional, sporting or personal activities.",
      "Sessions are delivered on yachts, in private villas, prestige hotels, private clubs or at exclusive events, with a level of discretion and service aligned with the standards of international luxury.",
      "In addition, Riviera Shockwaves partners with Exomobil to offer unique experiences around augmented mobility, exoskeletons and next-generation human technologies.",
    ],
    closing_hl: "While others offer comfort, we offer the recovery of capabilities.",
    closing: [
      "Riviera Shockwaves is not a wellness service.",
      "It is a new approach to regeneration, recovery and human performance.",
    ],
    signature_top: "BY INVITATION ONLY",
    signature_main: "We give you back your capacities.",
    signature_sub: "Elite regeneration protocols — on board, by invitation or personal request.",
  },
  it: {
    overline: "MANIFESTO · CERCHIO PRIVATO",
    headline: "Il vero lusso non è il tempo. È ritrovare pienamente le proprie capacità fisiche, la propria energia e la libertà di movimento.",
    chapters: ["Il cerchio", "Il protocollo", "La promessa"],
    paras: [
      "Riviera Shockwaves è un cerchio privato dedicato a coloro che considerano il proprio corpo il loro bene più prezioso.",
      "Offriamo un accesso estremamente selettivo a protocolli di rigenerazione avanzati, pensati per armatori di yacht, equipaggi, dirigenti, imprenditori, sportivi e clienti VIP più esigenti.",
      "La nostra missione è semplice: permettere a ciascuno di recuperare più rapidamente, ritrovare maggiore mobilità, migliorare il comfort fisico e mantenere nel tempo il proprio livello di prestazione.",
      "Quando la maggior parte degli approcci propone comfort o benessere, noi ci concentriamo su un obiettivo diverso: aiutare il corpo a ritrovare il suo pieno potenziale.",
    ],
    pull: "Non vendiamo trattamenti. Aiutiamo le persone più esigenti a ritrovare un livello fisico che a volte credevano di aver perso.",
    paras2: [
      "I nostri protocolli esclusivi combinano diverse tecnologie di stimolazione e rigenerazione di ultima generazione, selezionate e adattate individualmente dai nostri specialisti.",
      "Ogni intervento è unico. Ogni persona riceve un protocollo personalizzato. Ogni esperienza è concepita per produrre un impatto concreto sul fisico, sull'energia e sulla capacità di godere pienamente della propria attività professionale, sportiva o personale.",
      "Le prestazioni si svolgono a bordo degli yacht, in ville private, hotel di prestigio, club privati o durante eventi esclusivi, con un livello di discrezione e servizio in linea con gli standard del lusso internazionale.",
      "In aggiunta, Riviera Shockwaves collabora con Exomobil per proporre esperienze uniche sulla mobilità aumentata, gli esoscheletri e le tecnologie umane di nuova generazione.",
    ],
    closing_hl: "Mentre altri offrono comfort, noi offriamo il recupero delle capacità.",
    closing: [
      "Riviera Shockwaves non è un servizio di benessere.",
      "È un nuovo approccio alla rigenerazione, al recupero e alla performance umana.",
    ],
    signature_top: "SOLO SU INVITO",
    signature_main: "Vi restituiamo le vostre capacità.",
    signature_sub: "Protocolli di rigenerazione d'élite — a bordo, su invito o richiesta personalizzata.",
  },
  ru: {
    overline: "МАНИФЕСТ · ЗАКРЫТЫЙ КРУГ",
    headline: "Истинная роскошь — это не время. Это вернуть себе физические возможности, энергию и свободу движения в полной мере.",
    chapters: ["Круг", "Протокол", "Обещание"],
    paras: [
      "Riviera Shockwaves — закрытый круг для тех, кто считает своё тело самым ценным активом.",
      "Мы предоставляем крайне избирательный доступ к продвинутым протоколам регенерации для владельцев яхт, экипажей, руководителей, предпринимателей, спортсменов и самых требовательных VIP-клиентов.",
      "Наша миссия проста: позволить каждому быстрее восстанавливаться, обрести большую подвижность, улучшить физический комфорт и устойчиво поддерживать свой уровень.",
      "Когда большинство подходов предлагает комфорт или wellness, мы сосредоточены на ином: помочь телу раскрыть полный потенциал.",
    ],
    pull: "Мы не продаём процедуры. Мы помогаем самым требовательным людям вернуть физический уровень, который они порой считали утраченным.",
    paras2: [
      "Наши эксклюзивные протоколы объединяют несколько технологий стимуляции и регенерации последнего поколения, отбираемых и адаптируемых под каждого индивидуально нашими специалистами.",
      "Каждое вмешательство уникально. Каждому подбирается персональный протокол. Каждый опыт создаётся, чтобы оказать осязаемое воздействие на тело, энергию и способность полноценно жить профессиональной, спортивной или личной жизнью.",
      "Сеансы проходят на борту яхт, в частных виллах, престижных отелях, частных клубах или на эксклюзивных мероприятиях, с уровнем деликатности и сервиса, соответствующим стандартам международной роскоши.",
      "Кроме того, Riviera Shockwaves сотрудничает с Exomobil, предлагая уникальный опыт с расширенной мобильностью, экзоскелетами и человеческими технологиями нового поколения.",
    ],
    closing_hl: "Когда другие предлагают комфорт, мы возвращаем возможности.",
    closing: [
      "Riviera Shockwaves — это не велнес-сервис.",
      "Это новый подход к регенерации, восстановлению и человеческой эффективности.",
    ],
    signature_top: "ТОЛЬКО ПО ПРИГЛАШЕНИЮ",
    signature_main: "Мы возвращаем вам ваши возможности.",
    signature_sub: "Элитные протоколы регенерации — на борту, по приглашению или по личному запросу.",
  },
};

export default function Manifesto() {
  const { lang } = useLang();
  const c = COPY[lang] || COPY.en;

  return (
    <section className="bg-[var(--surface-1)] hairline-t hairline-b py-24 md:py-32" data-testid="manifesto">
      <div className="container-luxe">
        {/* Top eyebrow + corner ticks for editorial feel */}
        <Reveal y={18}>
          <div className="flex items-center justify-between mb-12">
            <span className="overline">{c.overline}</span>
            <span className="text-[10px] uppercase tracking-[0.3em] text-[var(--ink)]/30 font-display hidden md:inline">
              Riviera Shockwaves — Monaco
            </span>
          </div>
        </Reveal>

        {/* Headline — Playfair italic */}
        <Reveal delay={0.08}>
          <h2 className="font-serif-luxe italic text-[28px] sm:text-4xl lg:text-[44px] text-[var(--ink)] leading-[1.1] max-w-5xl">
            {c.headline}
          </h2>
        </Reveal>

        {/* Chapter 01 — first body block */}
        <Reveal className="mt-16" delay={0.05}>
          <div className="chapter-marker mb-8">01 · {c.chapters[0]}</div>
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
            <div className="lg:col-span-7 space-y-5">
              {c.paras.map((p, i) => (
                <p key={i} className="text-[15px] md:text-base text-[var(--ink)]/85 leading-relaxed font-body">
                  {p}
                </p>
              ))}
            </div>
            <div className="lg:col-span-5 lg:pl-8 lg:border-l border-[var(--border-subtle)]">
              <p className="font-serif-luxe italic text-xl md:text-2xl text-[var(--ink)] leading-snug">
                « {c.pull} »
              </p>
            </div>
          </div>
        </Reveal>

        {/* Chapter 02 — second body block */}
        <Reveal className="mt-16" delay={0.05}>
          <div className="chapter-marker mb-8">02 · {c.chapters[1]}</div>
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
            <div className="lg:col-span-12 space-y-5">
              {c.paras2.map((p, i) => (
                <p key={i} className="text-[15px] md:text-base text-[var(--ink)]/85 leading-relaxed font-body max-w-4xl">
                  {p}
                </p>
              ))}
            </div>
          </div>
        </Reveal>

        {/* Chapter 03 — closing block, emphasized */}
        <Reveal className="mt-16" delay={0.05}>
          <div className="chapter-marker mb-8">03 · {c.chapters[2]}</div>
          <div className="p-8 md:p-12 hairline bg-[var(--surface-2)]">
            <p className="font-serif-luxe italic text-xl md:text-2xl text-[var(--ink)] leading-snug">
              « {c.closing_hl} »
            </p>
            <div className="mt-6 space-y-2">
              {c.closing.map((line, i) => (
                <p key={i} className="text-[15px] text-[var(--ink)]/80 leading-relaxed font-body">{line}</p>
              ))}
            </div>
          </div>
        </Reveal>

        {/* Signature — sur invitation */}
        <Reveal className="mt-14" delay={0.05}>
          <div className="flex flex-col items-start gap-3 hairline-t pt-10">
            <span className="overline">{c.signature_top}</span>
            <h3 className="font-display text-2xl md:text-3xl text-[var(--ink)] font-light tracking-tight">
              {c.signature_main}
            </h3>
            <p className="text-[13px] text-[var(--text-secondary)] font-body italic">
              {c.signature_sub}
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
